module.exports = __webpack_public_path__ + "fonts/text-security-disc-compat.5160d0e.woff2";